import { Stack } from '@mui/joy';
import type { ColDef } from 'ag-grid-community';
import type { ReactElement } from 'react';
import GButton from 'components/technical/inputs/GButton/GButton.tsx';
import type { PortfolioRow } from '../initialPortfolio/InitialPortfolioStep.tsx';
import { defaultRowSpacing } from '../../../../../StackSpacing.ts';
import Universe, { createInInitialPortfolioColumn } from '../../universe/Universe.tsx';
import {
  portfolioDefinitionNameColumn,
  portfolioDefinitionRebalancingRuleColumn,
  portfolioDefinitionTypeColumn,
} from '../PortfolioDefinitionSharedColumns.ts';
import { useWatch } from 'react-hook-form';
import { syncOutlookWithGivenUniverseFields } from '../../assumptionsAndOutlook/AssumptionsAndOutlook.utils.ts';
import type { PortfolioOptimizerInputFields } from '../PortfolioOptimizer.validation.ts';

const PortfolioUniverseStep = ({
  optimizableFunds,
  goToNextStep,
}: {
  optimizableFunds: PortfolioRow[];
  goToNextStep: () => void;
}): ReactElement => {
  const givenPortfolio = useWatch({ name: 'givenPortfolio' });

  const columns: ColDef<PortfolioRow>[] = [
    portfolioDefinitionNameColumn,
    portfolioDefinitionTypeColumn,
    portfolioDefinitionRebalancingRuleColumn,
    createInInitialPortfolioColumn(givenPortfolio),
  ];

  return (
    <Stack spacing={defaultRowSpacing}>
      <Universe<PortfolioRow, PortfolioOptimizerInputFields>
        columnDefs={columns}
        rowData={optimizableFunds}
        idGetter={(row) => row?.id ?? ''}
        syncSelection={({ getValues, setValue, clearErrors }) =>
          syncOutlookWithGivenUniverseFields(getValues, setValue, clearErrors)
        }
      />
      <GButton onClick={goToNextStep} sx={{ marginLeft: 'auto' }}>
        Next
      </GButton>
    </Stack>
  );
};

export default PortfolioUniverseStep;
